export const isAndroid = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes('android');
};
